const isDesktop = window.matchMedia('(min-width: 1025px)');

/* from US header.js */
function attachOverlayEventListeners(block) {
  // Megamenu overlay event listeners
  const menuItems = block.querySelectorAll('.megamenu-item');
  const overlay = block.querySelector('.header-overlay');

  menuItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      overlay.classList.add('active');
    });

    item.addEventListener('mouseleave', () => {
      overlay.classList.remove('active');
    });
  });
}

/* from US megamenu.js */
function collapseAllMenuItems() {
  const megamenu = document.querySelector('.megamenu');
  const activeMenuItems = megamenu && megamenu.querySelectorAll('[aria-expanded=true]');
  if (activeMenuItems.length > 0) {
    [...activeMenuItems].forEach((activeMenuItem) => {
      activeMenuItem.setAttribute('aria-expanded', false);
    });
    const mobileHeader = document.querySelector('.megamenu-mobile-header');
    mobileHeader.classList.remove('d-none');
  }
}

function handleBackNavigation(event) {
  const { target } = event;
  const closestMenu = target.closest('.megamenu-submenu') || target.closest('.megamenu-list');
  const activeMenuItems = closestMenu && closestMenu.querySelectorAll('[aria-expanded=true]');
  const closableActiveMenuItem = [...activeMenuItems].find((menuItem) => {
    if (menuItem.classList.contains('megamenu-submenu-item')) {
      return menuItem;
    }

    return isDesktop.matches || !menuItem.classList.contains('has-submenu');
  });

  if (closableActiveMenuItem) {
    event.preventDefault();
    const mobileHeader = document.querySelector('.megamenu-mobile-header');
    closableActiveMenuItem.setAttribute('aria-expanded', false);
    mobileHeader.classList.remove('d-none');
  }
}

function showSelectedMenu(selectedMenuItem, firstMobileLevel = false) {
  // On mobile or tablet, toggle sub-menu if applicable
  // on mobile, check to see if you are logged in or not

  // Scroll megamenu block to the top
  const megamenu = document.querySelector('.megamenu');
  megamenu.scrollTop = 0;

  if (
    !isDesktop.matches
    && selectedMenuItem.classList.contains('megamenu-item')
    && selectedMenuItem.classList.contains('has-submenu')
  ) {
    const isExpanded = selectedMenuItem.getAttribute('aria-expanded') === 'true';
    selectedMenuItem.setAttribute('aria-expanded', !isExpanded);
    return;
  }

  // Close currently active menu item. Do not close item with sub menu on mobile/tablet
  const menus = selectedMenuItem.closest('.megamenu-submenu')
    || selectedMenuItem.closest('.megamenu-list');
  const currentActiveItems = menus && menus.querySelectorAll('[aria-expanded=true]');
  const closableActiveMenuItems = [...currentActiveItems].filter((menuItem) => {
    if (menuItem.classList.contains('megamenu-submenu-item')) {
      return menuItem;
    }

    return isDesktop.matches || !menuItem.classList.contains('has-submenu');
  });

  if (closableActiveMenuItems.length > 0) {
    closableActiveMenuItems.forEach((menuItem) => {
      menuItem.setAttribute('aria-expanded', false);
    });
  }

  selectedMenuItem.setAttribute('aria-expanded', true);

  // Scroll megamenu submenu to the top
  if (!isDesktop.matches) {
    const submenuContainer = selectedMenuItem.querySelector('.megamenu-column-container');
    if (submenuContainer) {
      submenuContainer.scrollTop = 0;
    }
  }

  if (!firstMobileLevel) {
    const mobileHeader = document.querySelector('.megamenu-mobile-header');
    mobileHeader.classList.add('d-none');
  }

  // Show first sub menu item as selected in desktop
  if (isDesktop.matches && selectedMenuItem.classList.contains('has-submenu')) {
    const subMenu = selectedMenuItem.querySelector('.megamenu-submenu');
    const defaultSubMenuItem = subMenu.firstElementChild;
    showSelectedMenu(defaultSubMenuItem);
  }
}

function toggleMobileMenu(forceExpanded = null) {
  const nav = document.getElementById('nav');
  if (!nav) {
    return;
  }

  const wasExpanded = forceExpanded !== null
    ? !forceExpanded
    : nav.getAttribute('aria-expanded') === 'true';
  const button = nav.querySelector('.nav-hamburger button');

  if (wasExpanded) {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.classList.remove('c-nav-open');
    const { scrollY } = document.body.dataset;
    window.scrollTo(0, parseInt(scrollY || '0', 10));
  } else {
    const { scrollY } = window;
    document.body.dataset.scrollY = scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.classList.add('c-nav-open');
  }

  nav.setAttribute('aria-expanded', wasExpanded ? 'false' : 'true');
  button.setAttribute(
    'aria-label',
    wasExpanded ? 'Open navigation' : 'Close navigation',
  );

  if (wasExpanded) {
    collapseAllMenuItems();
    const searchInput = document.querySelector('.megamenu-mobile-header input[type="search"]');
    searchInput.value = '';
  } else {
    const megamenu = document.querySelector('.megamenu');
    const mainMenuItemWithSubMenus = megamenu && megamenu.querySelector('.megamenu-item.has-submenu');
    if (mainMenuItemWithSubMenus) {
      showSelectedMenu(mainMenuItemWithSubMenus, true);
    }
  }
}

function handleMenuClose(event) {
  event.preventDefault();
  const overlay = document.querySelector('.header-overlay');
  overlay.classList.remove('active');

  toggleMobileMenu(false);
  document.querySelector('.nav-hamburger button').focus();
}

function getSelectedMenuItem(target) {
  // Check if target is menu item itself or button iside it
  return [target, target.parentElement].find(
    (menuItem) => menuItem
      && (menuItem.classList.contains('megamenu-submenu-item')
        || menuItem.classList.contains('megamenu-item')),
  );
}

function isTarget(selector, event) {
  const { target } = event;
  const potentialTargets = document.querySelectorAll(selector);
  return [...potentialTargets].find(
    (potentialTarget) => potentialTarget
      && (potentialTarget === target || potentialTarget.contains(target)),
  );
}

function closeOnEscape(e) {
  if (e.code === 'Escape') {
    if (isDesktop.matches) {
      collapseAllMenuItems();
    } else if (!isDesktop.matches) {
      // eslint-disable-next-line no-use-before-define
      toggleMobileMenu(false);
      document.querySelector('.nav-hamburger button').focus();
    }
  }
}

function attachMegamenuEventListeners(block) {
  const handleEvent = async (event) => {
    const { target } = event;

    if (isTarget('.megamenu-submenu-header .back', event)) {
      handleBackNavigation(event);
      return;
    }

    if (
      isTarget('.megamenu-submenu-header .close', event)
      || isTarget('.megamenu-mobile-header .close', event)
    ) {
      handleMenuClose(event);
      return;
    }

    const selectedMenuItem = getSelectedMenuItem(target);

    if (selectedMenuItem) {
      showSelectedMenu(selectedMenuItem);
    }
  };

  block.addEventListener('click', async (event) => {
    // Menu selection works on hover in desktop
    if (isDesktop.matches) {
      return;
    }

    await handleEvent(event);
  });

  window.addEventListener('keydown', async (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      await handleEvent(event);
    }

    if (event.key === 'Escape') {
      closeOnEscape(event);
    }
  });

  isDesktop.addEventListener('change', (e) => {
    // Toggle off mobile menu when switched to desktop
    if (e.matches) {
      toggleMobileMenu(false);
    } else {
      // Reset panel heights when switched to mobile
      const subMenuPanels = document.querySelectorAll(
        '.megamenu-submenu-panel',
      );
      [...subMenuPanels].forEach((subMenuPanel) => {
        if (subMenuPanel.hasAttribute('style')) {
          subMenuPanel.style.removeProperty('height');
        }
      });
    }
  });

  const aTags = block.querySelectorAll('a');
  aTags.forEach((aTag) => {
    aTag.addEventListener('click', (e) => {
      window.adobeDataLayer.push({
        event: 'navigation-link-clicked',
        eventInfo: {
          linkId: e.currentTarget.getAttribute('data-link-id')?.toString(),
        },
      });
    });
  });
}

document.addEventListener( 'DOMContentLoaded', function() {
  attachOverlayEventListeners(document.querySelector('.c-base-us__header'));
  attachMegamenuEventListeners(document.querySelector('.megamenu'));

  const hamburger = document.querySelector('.nav-hamburger');
  hamburger.addEventListener('click', () => toggleMobileMenu());
} );
